<script>
import { IonHeader } from '@ionic/vue'

export default IonHeader
</script>
